/*!
 * Image with text — redare video doar cat e vizibil pe ecran.
 *
 * Videoclipurile nu au `autoplay`: redarea o controleaza codul de aici, ca sa nu
 * consume banda si CPU cand sectiunea e sub fold sau cand tab-ul e in fundal.
 */
(function () {
  const VIDEO_SELECTOR = 'video[data-iwt-video]';
  const VISIBLE_RATIO = 0.25;

  // Videoclipurile aflate in viewport; folosite la pauza pe tab ascuns.
  const playing = new Set();

  let observer = null;

  function getObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            playing.add(video);
            if (!document.hidden) video.play().catch(() => {});
          } else {
            playing.delete(video);
            video.pause();
          }
        });
      },
      { threshold: VISIBLE_RATIO }
    );

    return observer;
  }

  function init(root) {
    // Preferintele utilizatorului au prioritate: fara redare automata daca a cerut
    // mai putina miscare sau navigheaza cu economie de date.
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return;
    if (!('IntersectionObserver' in window)) return;

    const videos = (root || document).querySelectorAll(VIDEO_SELECTOR);
    if (!videos.length) return;

    const io = getObserver();
    videos.forEach((video) => io.observe(video));
  }

  document.addEventListener('visibilitychange', () => {
    playing.forEach((video) => {
      if (document.hidden) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
